import { persistContactAuthToken } from './persistContactAuthToken'

export const SHELL_AUTH_MESSAGE_TYPE = 'sigchat-shell-auth-v1'
export const SHELL_AUTH_READY_MESSAGE_TYPE = 'sigchat-shell-auth-ready-v1'

export type ShellAuthMessage = {
  type: typeof SHELL_AUTH_MESSAGE_TYPE
  smartAuth: string
  contactToken: string
}

export type ShellAuthReadyMessage = {
  type: typeof SHELL_AUTH_READY_MESSAGE_TYPE
  contactToken: string
}

export type ShellAuthPreload = {
  smartAuth: string
  contactToken: string
}

declare global {
  interface Window {
    __SIGCHAT_SHELL_AUTH__?: ShellAuthPreload
  }
}

function isShellAuthReadyMessage(data: unknown): data is ShellAuthReadyMessage {
  if (typeof data !== 'object' || data === null) return false
  const msg = data as ShellAuthReadyMessage
  return msg.type === SHELL_AUTH_READY_MESSAGE_TYPE && typeof msg.contactToken === 'string'
}

export function publishShellAuth(
  smartAuth: string,
  contactToken: string,
  jwtPayload: Record<string, unknown> | null,
): void {
  persistContactAuthToken(smartAuth, jwtPayload)
  window.__SIGCHAT_SHELL_AUTH__ = { smartAuth, contactToken }
}

export function postShellAuthToFrame(
  frame: HTMLIFrameElement,
  smartAuth: string,
  contactToken: string,
): void {
  const target = frame.contentWindow
  if (!target) return
  const message: ShellAuthMessage = {
    type: SHELL_AUTH_MESSAGE_TYPE,
    smartAuth,
    contactToken,
  }
  const childOrigin = (() => {
    try {
      return new URL(frame.src).origin
    } catch {
      return '*'
    }
  })()
  target.postMessage(message, childOrigin)
}

export function installShellAuthReadyListener(
  onReady: (contactToken: string) => void,
): () => void {
  const handler = (event: MessageEvent) => {
    if (!isShellAuthReadyMessage(event.data)) return
    onReady(event.data.contactToken)
  }
  window.addEventListener('message', handler)
  return () => window.removeEventListener('message', handler)
}
